module.exports = __webpack_public_path__ + "img/msi_blank.5810e92c.svg";